export default __webpack_public_path__ + "static/media/Z3plus.a60ed008.svg";